import { Injectable } from "@angular/core";
import { Observable, combineLatest, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { AdvisorStateService } from "../state/advisor.state.service";
import { AdvisorDataService } from "../services/advisor.data.service";
import { BrandingService } from "../../../core/branding/branding.service";
import { CompanyBrandingHelper } from "../../branding/branding.helper";
import { AdvisorData } from "../advisor.model";

export interface AdvisorWithDisplayPhone extends AdvisorData {
  displayPhone: string;
}

@Injectable({
  providedIn: "root",
})
export class AdvisorFacade {
  constructor(
    private stateService: AdvisorStateService,
    private dataService: AdvisorDataService,
    private brandingService: BrandingService
  ) {}

  getAdvisorWithPhone$(advisorId: number): Observable<AdvisorWithDisplayPhone | null> {
    if (!advisorId) {
      return of(null);
    }

    return combineLatest([
      this.getAdvisor$(advisorId),
      this.brandingService.getBranding$()
    ]).pipe(
      map(([advisor, branding]) => {
        if (!advisor) {
          return null;
        }

        const displayPhone = CompanyBrandingHelper.getAdvisorPhone(
          branding,
          advisor.phone
        );

        return {
          ...advisor,
          displayPhone
        };
      })
    );
  }

  getAdvisor$(advisorId: number): Observable<AdvisorData> {
    if (this.stateService.isAdvisorLoaded(advisorId)) {
      return this.stateService.getAdvisor$(advisorId);
    }

    return this.updateAdvisor(advisorId).pipe(
      switchMap(() => this.stateService.getAdvisor$(advisorId))
    );
  }

  private updateAdvisor(advisorId: number): Observable<AdvisorData> {
    return this.dataService.get(advisorId).pipe(
      map((advisor) => {
        this.stateService.setAdvisor(advisorId, advisor);
        return advisor;
      })
    );
  }
}
